module.exports = __webpack_public_path__ + "static/media/carte-grise-sans.bd064d0f.png";